module.exports = __webpack_public_path__ + "static/media/  (62).dc816310.jpg";